/**
 * Terminal bytes cross the socket as base64. What the device sends is bytes —
 * UTF-8 for anything modern — and xterm decodes bytes it is handed as UTF-8,
 * keeping a character whole when it is split across two messages. What the user
 * types arrives as a JS string and leaves as its UTF-8 bytes.
 *
 * `atob`/`btoa` alone only carry Latin-1: output came out one character per
 * byte (`é` as `Ã©`), and typing anything above U+00FF threw (frontend#19).
 */

/** Device output from the socket, as the bytes the device sent. */
export function decodeOutput(data: string): Uint8Array {
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

/** Typed text, as the base64 of the UTF-8 bytes the device reads. */
export function encodeInput(text: string): string {
  let binary = '';
  for (const byte of new TextEncoder().encode(text)) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary);
}

/**
 * xterm's binary input (some mouse reports): one byte per character, not text,
 * so it goes as it is.
 */
export function encodeBinaryInput(binary: string): string {
  return btoa(binary);
}
